// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_segmentPopup__-VkdK {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px;
  border: 1px solid #ddd;
  background-color: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 400px;
  border-radius: 12px;
}
.styles_segmentPopup__-VkdK .styles_audience__4fJni {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
.styles_segmentPopup__-VkdK h3 {
  font-size: 18px;
  font-weight: 500;
}
.styles_segmentPopup__-VkdK label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #6ba7a8;
  font-weight: 500;
}
.styles_segmentPopup__-VkdK label textarea {
  resize: none;
}
.styles_segmentPopup__-VkdK label input,
.styles_segmentPopup__-VkdK label textarea,
.styles_segmentPopup__-VkdK label select {
  border-radius: 12px;
  border: 1px solid rgba(107, 167, 168, 0.5);
  padding: 8px;
}
.styles_segmentPopup__-VkdK .styles_save__PJrBZ,
.styles_segmentPopup__-VkdK .styles_close__Rnwz7,
.styles_segmentPopup__-VkdK .styles_delete__IKjki {
  border-radius: 12px;
  padding: 8px 16px;
  color: #fff;
  font-weight: 600;
  transition: opacity 0.2s ease-in-out;
}
.styles_segmentPopup__-VkdK .styles_save__PJrBZ:hover,
.styles_segmentPopup__-VkdK .styles_close__Rnwz7:hover,
.styles_segmentPopup__-VkdK .styles_delete__IKjki:hover {
  opacity: 0.8;
  cursor: pointer;
}
.styles_segmentPopup__-VkdK .styles_save__PJrBZ {
  background-color: rgb(46, 114, 46);
  border: 1px solid rgb(46, 114, 46);
}
.styles_segmentPopup__-VkdK .styles_close__Rnwz7 {
  background-color: #6ba7a8;
  border: 1px solid #6ba7a8;
}
.styles_segmentPopup__-VkdK .styles_delete__IKjki {
  background-color: #bb5240;
  border: 1px solid #bb5240;
}

.styles_popupBackdrop__sAqAB {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(1px);
          backdrop-filter: blur(1px);
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/Transcript/SegmentPopup/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAGI;EACE,YAAA;AADN;AAII;;;EAGE,mBAAA;EACA,0CAAA;EACA,YAAA;AAFN;AAME;;;EAGE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;AAJJ;AAMI;;;EACE,YAAA;EACA,eAAA;AAFN;AAKE;EACE,kCAAA;EACA,kCAAA;AAHJ;AAKE;EACE,yBAAA;EACA,yBAAA;AAHJ;AAKE;EACE,yBAAA;EACA,yBAAA;AAHJ;;AAMA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,YAAA;AAHF","sourcesContent":[".segmentPopup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 24px;\n  border: 1px solid #ddd;\n  background-color: #fff;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 400px;\n  border-radius: 12px;\n\n  .audience {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 4px;\n  }\n\n  h3 {\n    font-size: 18px;\n    font-weight: 500;\n  }\n\n  label {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    color: #6ba7a8;\n    font-weight: 500;\n\n    textarea {\n      resize: none;\n    }\n\n    input,\n    textarea,\n    select {\n      border-radius: 12px;\n      border: 1px solid rgba(107, 167, 168, 0.5);\n      padding: 8px;\n    }\n  }\n\n  .save,\n  .close,\n  .delete {\n    border-radius: 12px;\n    padding: 8px 16px;\n    color: #fff;\n    font-weight: 600;\n    transition: opacity 0.2s ease-in-out;\n\n    &:hover {\n      opacity: 0.8;\n      cursor: pointer;\n    }\n  }\n  .save {\n    background-color: rgb(46, 114, 46);\n    border: 1px solid rgb(46, 114, 46);\n  }\n  .close {\n    background-color: #6ba7a8;\n    border: 1px solid #6ba7a8;\n  }\n  .delete {\n    background-color: #bb5240;\n    border: 1px solid #bb5240;\n  }\n}\n.popupBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.2);\n  backdrop-filter: blur(1px);\n  z-index: 999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"segmentPopup": `styles_segmentPopup__-VkdK`,
	"audience": `styles_audience__4fJni`,
	"save": `styles_save__PJrBZ`,
	"close": `styles_close__Rnwz7`,
	"delete": `styles_delete__IKjki`,
	"popupBackdrop": `styles_popupBackdrop__sAqAB`
};
export default ___CSS_LOADER_EXPORT___;
